import { create } from 'apisauce';

import { Config } from '@nw/shared/config';

import { IbUserAccountsGraphQlServiceTypes } from '.';

class IbUserAccountsGraphQlService
  implements IbUserAccountsGraphQlServiceTypes
{
  api: Record<string, any>;
  networkCallWithGraphQL: any;
  constructor(networkCallWithGraphQL: any) {
    this.api = create({
      baseURL: `${Config['IB_USER_ACCOUNT_GRAPHQL_BASE_URL']}`
    });
    this.networkCallWithGraphQL = networkCallWithGraphQL;
  }

  ibUserAccountsGraphQlQuery = (
    query: string,
    customNetworkCallWithGraphQL?
  ) => {
    const requestObject = {
      query: query,
      variables: {}
    };

    if (customNetworkCallWithGraphQL) {
      return customNetworkCallWithGraphQL(this.api, requestObject);
    } else return this.networkCallWithGraphQL(this.api, requestObject);
  };

  ibUserAccountsGraphQlMutation = (
    mutation: string,
    data: Record<string, any>,
    customNetworkCallWithGraphQL?
  ) => {
    const requestObject = {
      query: mutation,
      variables: data
    };

    if (customNetworkCallWithGraphQL) {
      return customNetworkCallWithGraphQL(this.api, requestObject);
    } else return this.networkCallWithGraphQL(this.api, requestObject);
  };
}

export { IbUserAccountsGraphQlService };
